import { createContext } from "react";

import type { AnyPartnerConfiguration } from "@gamedev-web/gamedev-sdk-core";
import type { PartnerConfigLce } from "./types";

export type PartnerContextType = {
  partnerLoadingState: { [partnerId: string]: PartnerConfigLce };
  partnerConfigs: { [partnerId: string]: AnyPartnerConfiguration };
  loadPartner: (partnerId: string) => Promise<void>;
  getPartnerConfigForPath(path: string): AnyPartnerConfiguration | undefined;
};

export const PartnerContext = createContext<PartnerContextType>({} as never);
